import React from "react";
import { classNames } from "../../../helpers/classNames";

const SelectBoxButton = ({ className, ...props }) => {
  return (
    <div
      ref={props?.setTargetElement}
      className={classNames(
        "w-fit h-fit",
        props?.disabled ? "opacity-60 cursor-not-allowed" : "",
        className
      )}
      onClick={() => {
        if (!props?.disabled) {
          props?.toggleOpen();
        }
      }}
    >
      {props?.children}
    </div>
  );
};

export default SelectBoxButton;
